import { useCallback, useEffect, useState } from "react";
import { getChat, onLive } from "../lib/live";

const merge = (prev, list) => {
  const ids = new Set(prev.map((m) => m.id));
  const fresh = (Array.isArray(list) ? list : []).filter((m) => m && !ids.has(m.id));
  if (!fresh.length) return prev;
  return [...prev, ...fresh].sort((a, b) => String(a.at).localeCompare(String(b.at)));
};

export function useLiveChat() {
  const chat = getChat();
  const [cfg, setCfg] = useState(null);
  const [msgs, setMsgs] = useState([]);
  const [status, setStatus] = useState({ online: false, typing: false });

  useEffect(() => {
    if (!chat) return undefined;
    let alive = true;
    chat.config().then((c) => { if (alive) setCfg(c); }).catch(() => {});
    const off = onLive((list) => setMsgs((prev) => merge(prev, list)), (s) => setStatus(s || {}));
    return () => { alive = false; off(); };
  }, [chat]);

  const reset = useCallback(() => {
    chat?.reset();
    setMsgs([]);
  }, [chat]);

  return { chat, cfg, msgs, status, reset };
}
